import {KarenLayers, Layers} from "../../../view/KarenLayers";
import {TimelineLite, gsap} from "gsap";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {SpinePlayer} from "../../../../core/displayObject/SpinePlayer";
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";

export class BigWinView {

    private _layer: StageLayer;
    private _bigWinSpine: SpinePlayer;
    private _dimmer: PIXI.Graphics;

    constructor() {
        this._layer = KarenLayers.getLayer(Layers.BIG_WIN)!;
        this.createBackground();
        this.createBigWinText();
    }

    public getLevelAnimation(level: number): TimelineLite {

        this._bigWinSpine.alpha = 1;
        this._bigWinSpine.position.set(360, 310);
        const tl: TimelineLite = new TimelineLite();
        tl.add(() => {
            gsap.to(this._dimmer, 0.2, {alpha: 0.5})
        }, 0);
        tl.add(this._bigWinSpine.play({
            name: "big_win_" + (level + 1) + "_start",
            loop: false,
            showOnEnd: true,
        }).add(() => {
            this._bigWinSpine.play({
                name: "big_win_" + (level + 1),
                loop: true,
                showOnEnd: true,
            })
        }));
        this._layer.addChild(this._bigWinSpine);
        return tl;
    }

    public remove(): TimelineLite {
        const tl: TimelineLite = gsap.timeline();
        if (this._bigWinSpine.visible) {
            tl.add(gsap.to(this._bigWinSpine, {
                duration: 0.5,
                alpha: 0,
                y: NolimitApplication.screenBounds.height,
                ease: `power2.in`
            }), `+=0.2`); // stay a short while after count up.
            tl.add(() => {
                this._bigWinSpine.visible = false;
            });
        }
        return tl;
    }

    public playEnding(level: number): TimelineLite {
        //showing end state #200
        const tl: TimelineLite = new TimelineLite();
        tl.add(gsap.to(this._dimmer, 0.2, {alpha: 0}));
        return tl;
    }

    public playBigWinEnding(level: number): TimelineLite {
        //showing end state #199
        const tl: TimelineLite = new TimelineLite();
        tl.add(gsap.to(this._dimmer, 0.1, {alpha: 0}));
        tl.add(this._bigWinSpine.play({
            name: "big_win_" + (level + 1),
            loop: false,
            duration: 0.2,
            showOnEnd: false,
        }), 0);
        return tl;
    }

    public stay(): TimelineLite {
        return gsap.timeline();
    }

    private createBigWinText(): void {
        this._bigWinSpine = new SpinePlayer("big_win_animation", false);
        this._bigWinSpine.position.set(360, 310);
        this._layer.addChild(this._bigWinSpine);
    }

    private createBackground(): void {
        const dimension: number = Math.max(NolimitApplication.screenBounds.width, NolimitApplication.screenBounds.height);
        this._dimmer = new PIXI.Graphics();
        this._dimmer.beginFill(0x000000, 1);
        this._dimmer.drawRect(0, 0, dimension+500, dimension+500);
        this._dimmer.endFill();
        this._dimmer.alpha = 0;
        this._layer.addChild(this._dimmer);
        this._dimmer.pivot.set(this._dimmer.width / 2, this._dimmer.height / 2);
        this._dimmer.position.set(360);
    }
}
